import React from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="container animate-fade-in" style={{ textAlign: 'center', marginTop: '60px' }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '16px', background: '-webkit-linear-gradient(45deg, #6366f1, #ec4899)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
        Welcome to Bhetcha RSVP
      </h1>
      <p style={{ fontSize: '1.2rem', color: '#6b7280', marginBottom: '40px' }}>
        Manage your events seamlessly with our modern platform.
      </p>

      <div style={{ marginBottom: '40px' }}>
        <p style={{ fontSize: '1rem', color: '#6366f1', fontWeight: '600', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>
          Brought to you by Bhetcha app
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <a href="https://play.google.com/store/apps/details?id=com.bhetcha.app.dev" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block' }}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
              style={{ height: '60px', transition: 'transform 0.2s' }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            />
          </a>
          <a href="https://apps.apple.com/np/app/bhetcha/id6738692626" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block' }}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
              alt="Download on the App Store"
              style={{ height: '60px', transition: 'transform 0.2s' }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            />
          </a>
        </div>

        <Link to="/login">
          <button style={{ padding: '14px 48px', fontSize: '18px', borderRadius: '30px' }}>
            Get Started
          </button>
        </Link>
      </div>
    </div>
  );
}
